module.exports = __webpack_public_path__ + "fonts/CrimsonText-BoldItalic.41673bb1.woff";